<template>
  <div class="pipeline-step mb-2">
    <div class="step-content d-flex">
      <div
        class="icon-column d-flex flex-column align-items-center flex-shrink-0"
        style="width: 2.5rem"
      >
        <div
          :class="[
            'pipeline-icon',
            iconBgClass,
            'bg-body rounded-circle d-flex align-items-center justify-content-center border border-2 mb-2 flex-shrink-0',
          ]"
          style="width: 2.5rem; height: 2.5rem; z-index: 2"
        >
          <font-awesome-icon :icon="icon" :class="iconTextClass" />
        </div>
      </div>
      <div class="pipeline-text pt-1 flex-grow-1 ms-3">
        <span v-if="title" class="d-block fw-bold fs-8 mb-1">
          {{ title }}
        </span>
        <span v-if="description" class="d-block text-gray-700 fs-8 lh-lg">
          {{ description }}
        </span>
        <span
          v-if="badgeText"
          :class="['d-block fs-9 fw-semibold mt-2', badgeTextClass]"
        >
          <font-awesome-icon
            v-if="badgeIcon"
            :icon="badgeIcon"
            class="me-1"
            size="xs"
          />
          {{ badgeText }}
        </span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

withDefaults(
  defineProps<{
    icon: string;
    iconBgClass: string; // e.g., 'bg-primary-subtle'
    iconTextClass: string; // e.g., 'text-primary'
    title: string;
    description: string;
    badgeText?: string;
    badgeIcon?: string;
    badgeTextClass?: string; // e.g., 'text-warning'
  }>(),
  {
    badgeText: "",
    badgeIcon: "",
    badgeTextClass: "",
  }
);
</script>
